import { Component, Input, OnInit, inject } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TagModel } from 'src/app/models/tag.model';
import { TagService } from 'src/app/services/tag.service';
import { ToastService } from 'src/app/services/toast.service';
import { CommonFunctionsConfiguratorService } from 'src/app/shared/services/swal-fire-configurator.service';
import { TagUpdateService } from '../../services/tag-update.service';
import { NgStyle } from '@angular/common';
import { MatCard, MatCardContent, MatCardActions } from '@angular/material/card';
import { MatButton } from '@angular/material/button';
import { ColorPickerModule } from 'ngx-color-picker';

export const DEFAULT_TAG_COLOR = '#00BDCB';

// The tag panel opens in the top-right corner where toasts appear; show its toasts at the bottom so they don't cover it.
const TAG_TOAST = { positionClass: 'toast-bottom-right' };

@Component({
    selector: 'app-tag',
    templateUrl: './tag.component.html',
    styleUrl: './tag.component.scss',
    imports: [NgStyle, MatButton, FormsModule, ReactiveFormsModule, ColorPickerModule]
})
export class TagComponent implements OnInit {
  private readonly tagSrv = inject(TagService);
  toastr = inject(ToastService);
  private readonly swalFire = inject(CommonFunctionsConfiguratorService);
  private readonly tagUpdateService = inject(TagUpdateService);


  @Input() visibility: boolean = false;

  addTagFlag: boolean = false;
  color: string = DEFAULT_TAG_COLOR;
  tags: TagModel[] = [];
  tagForm = new UntypedFormGroup({
    id: new UntypedFormControl(null),
    name: new UntypedFormControl(null),
    color: new UntypedFormControl(this.color),
  });

  ngOnInit(): void {
    this.getTags();
  }

  selectTagToEdit(tag: TagModel) {
    this.tagForm.patchValue(tag);
    this.color = tag.color;
    this.addTagFlag = true;
  }

  cancelTagToEdit() {
    this.tagForm.reset();
    this.color = DEFAULT_TAG_COLOR;
    this.addTagFlag = false;
  }

  getTags() {
    this.tagSrv.getTags().subscribe({
      next: (data) => {
        this.tags = data;
      },
      error: (err) => {
        this.toastr.error(
          'Etiquetas',
          'No se pudo obtener la lista etiquetas.',
          TAG_TOAST
        );
      },
    });
  }

  validateTasks(tagId: any) {
    this.tagSrv.countTaskTagByTagId(tagId).subscribe({
      next: (count) => {
        if (count == 0) {
          this.removeTag(tagId);
        }
        else {
          this.swalFire
            .SwalFireQuestion(
              'Eliminar etiqueta',
              `La etiqueta que desea eliminar tiene ${count} tareas asociadas. ¿Está seguro que desea eliminarla?`,
              'Eliminar',
              'Cancelar'
            )
            .then((result) => {
              if (result.isConfirmed) {
                this.removeTag(tagId);
              }
            });
        }
      },
      error: (err) => {
        this.toastr.error(
          'Etiquetas',
          'No se ha podido eliminar la etiqueta.',
          TAG_TOAST
        );
      },
    });
  }

  removeTag(tagId: any) {
    this.tagSrv.deleteTag(tagId).subscribe({
      next: (data) => {
        this.getTags();
        this.tagUpdateService.notifyTagsUpdated();
        this.toastr.success(
          'Etiquetas',
          'La etiqueta se eliminó correctamente.',
          TAG_TOAST
        );
      },
      error: (err) => {
        this.toastr.error(
          'Etiquetas',
          'No se ha podido eliminar la etiqueta.',
          TAG_TOAST
        );
      },
    });
  }

  saveTag() {
    this.tagForm.controls.color.patchValue(this.color)
    let tag = this.tagForm.value as TagModel;

    if (tag.id) {
      this.updateTag(tag);
    } else {
      this.addTag(tag);
    }

  }

  updateTag(tag: TagModel) {
    this.tagSrv.updateTag(tag).subscribe({
      next: (data) => {
        this.tagUpdateService.notifyTagsUpdated();
        this.getTags();
        this.color = DEFAULT_TAG_COLOR;
        this.tagForm.reset();
        this.addTagFlag = false;
        this.toastr.success(
          'Etiquetas',
          'La etiqueta se actualizó correctamente.',
          TAG_TOAST
        );
      },
      error: (err) => {
        this.toastr.error(
          'Etiquetas',
          'No se ha podido actualizar la etiqueta.',
          TAG_TOAST
        );
      },
    });
  }

  addTag(tag: TagModel) {
    this.tagSrv.addTag(tag).subscribe({
      next: (data) => {
        this.tagUpdateService.notifyTagsUpdated();
        this.getTags();
        this.color = DEFAULT_TAG_COLOR;
        this.tagForm.reset();
        this.addTagFlag = false;
        this.toastr.success(
          'Etiquetas',
          'La etiqueta se creó correctamente.',
          TAG_TOAST
        );
      },
      error: (err) => {
        this.toastr.error(
          'Etiquetas',
          'No se ha podido crear la etiqueta.',
          TAG_TOAST
        );
      },
    });
  }

  cancel() {
    this.color = DEFAULT_TAG_COLOR;
    this.tagForm.reset();
    this.addTagFlag = false;
  }

  disabled() {
    let name = this.tagForm.controls.name.value as unknown as string | null;
    return !name || name === '' || this.color === '';
  }

}
